<a *ngIf="history && history.length" class="m-3 my-4 hidden-phone back-absolute cursor-pointer" (click)="goBack()">
    <div class="d-flex align-items-center">
        <i class="fa-solid text-brand-40 fa-arrow-left"></i>
        <div class="col-10 truncate px-0">
            <p class="m-0 text-uppercase ls-label-medium-semibold text-brand-40">{{"BLOCK.BACK.BACK" | translate}}</p>
        </div>
    </div>
</a>

<div *ngIf="history && history.length" class="m-3 my-4 hidden-web col-3 cursor-pointer" (click)="goBack()">
    <div class="d-flex align-items-center">
        <i class="fa-solid text-brand-40 fa-arrow-left" aria-hidden="true"></i>
        <div class="col-10 truncate px-0">
            <p class="m-0 text-uppercase ls-label-medium-semibold text-brand-40">{{"BLOCK.BACK.BACK" | translate}}</p>
        </div>
    </div>
</div>